import { el } from "../lib/redom.es.min.js";
import { convertToCssName } from "../utils/string.js";

export class CmsCategoryInfo extends HTMLElement {
    defaultOptions: ICategoryInfoOptions = {
        categoriesInfo: [],
        showName: false,
        showImage: true,
        showListImage: true,
        showIconImage: true
    };
    
    options: ICategoryInfoOptions;

    constructor(options?: ICategoryInfoOptions) {
        super();

        if (options) {
            this.options = { ...this.defaultOptions, ...options };
        }
    }

    connectedCallback() {
        if (!this.options) {
            this.readOptionsFromAttributes();
        }

        this.render();
    }
    
    readOptionsFromAttributes() {
        this.options = {...this.defaultOptions};

        const contextAssetId = this.getAttribute("context-asset-id");
        if (contextAssetId) {
            const w = window as any;
            this.options.categoriesInfo = w.umwAssets[contextAssetId][0];
        }

        if (this.hasAttribute("show-name")) {
            const showName = this.getAttribute("show-name");
            if (showName && showName.length && (showName.toLowerCase() === "true" || showName === "1")) {
                this.options.showName = true;
            } else {
                this.options.showName = false;
            }
        }

        if (this.hasAttribute("show-image")) {
            const showIamge = this.getAttribute("show-image");
            if (showIamge && showIamge.length && (showIamge.toLowerCase() === "true" || showIamge === "1")) {
                this.options.showImage = true;
            } else {
                this.options.showImage = false;
            }
        }

        if (this.hasAttribute("show-list-image")) {
            const showListImage = this.getAttribute("show-list-image");
            if (showListImage && showListImage.length && (showListImage.toLowerCase() === "true" || showListImage === "1")) {
                this.options.showListImage = true;
            } else {
                this.options.showListImage = false;
            }
        }

        if (this.hasAttribute("show-icon-image")) {
            const showIconImage = this.getAttribute("show-icon-image");
            if (showIconImage && showIconImage.length && (showIconImage.toLowerCase() === "true" || showIconImage === "1")) {
                this.options.showIconImage = true;
            } else {
                this.options.showIconImage = false;
            }
        }
    }

    render(categoriesInfo?: ICategoryInfo[]) {
        if (categoriesInfo) {
            this.options.categoriesInfo = categoriesInfo;
        }

        if(!this.options.categoriesInfo.length)
            return;

        const children = [
            el("div.categories-info", 
                this.options.categoriesInfo.map(category => 
                    el("div.category-info", { class: 'category-info-name--' + convertToCssName(category.categoryName) },
                        this.options.showName && el("h3.category-info-name", category.categoryName),
                        this.options.showImage && category.imageUrl && 
                        el("span.category-info-image",
                            el("img", { 
                                src: category.imageUrl,
                                title: category.categoryName,
                                alt: category.categoryName
                            }),
                        ),
                        this.options.showListImage && category.listImageUrl &&
                        el("span.category-info-list-image",
                            el("img", { 
                                src: category.listImageUrl,
                                title: category.categoryName,
                                alt: category.categoryName
                            }),
                        ),
                        this.options.showIconImage && category.iconImageUrl &&
                        el("span.category-info-icon-image",
                            el("img", { 
                                src: category.iconImageUrl,
                                title: category.categoryName,
                                alt: category.categoryName
                            }),
                        )
                    )
                )
            )
        ];

        children.forEach(element => this.appendChild(element));
    }
}

interface ICategoryInfoOptions {
    categoriesInfo: ICategoryInfo[]
    showName: boolean;
    showImage: boolean;
    showListImage: boolean;
    showIconImage: boolean;
}

interface ICategoryInfo {
    categoryID: number,
    categoryName: string,
    imageUrl: string,
    listImageUrl: string,
    iconImageUrl: string
}

customElements.define('cms-category-info', CmsCategoryInfo);


